/************ ANNNOUNCEMENT BAR  STICKY VIEW START **************/
const checkInterval = setInterval(() => {
  const childElements = document.querySelectorAll('.announcement-bar--js');
  const hide_PageContainer_Overflow = document.getElementById("PageContainer");

  if (childElements.length > 0) {
    window.addEventListener('scroll', () => {
      // Get scroll position
      const scrollY = window.scrollY;
    
      childElements.forEach((ele, i) => {
        // Example: Add a class when scrollY > 100
        if (scrollY > 5) {
          ele.classList.add('section--sticky-announcementbar');
          if(hide_PageContainer_Overflow){
            if(window.innerWidth > 750){
              hide_PageContainer_Overflow.style.overflow = 'initial';
            }
          }
        } else {
          ele.classList.remove('section--sticky-announcementbar');
          if(hide_PageContainer_Overflow){
            if(window.innerWidth > 750){
              hide_PageContainer_Overflow.style.overflow = 'hidden';
            }
          }
        }
      })  
    })
    clearInterval(checkInterval); // Stop checking
  } else {
    console.log("Waiting for element...");
    setTimeout(() => {
      clearInterval(checkInterval); // Stop checking
    }, 10000);
  }
}, 500);

/************ ANNNOUNCEMENT BAR  STICKY VIEW END **************/

/************ DISCOUNT VIEW START **************/
// if (window.innerWidth < 749) {
//   const checkDiscountInterval = setInterval(() => {
//     const select_discount = document.querySelectorAll(".gf_pq-discount-selector");
//     const gryffeditor_div = document.querySelector(".gryffeditor");
    
//     if (select_discount.length > 0 && gryffeditor_div) {
//       gryffeditor_div.prepend(select_discount[0]);
//       setTimeout(() => {
//         const gf_discount = gryffeditor_div.querySelector(".gf_pq-discount");
//         if (gf_discount.firstChild) {
//           gf_discount.removeChild(gf_discount.firstChild);
//         }
//         const lastChild = gf_discount.lastElementChild;
//         if (lastChild) {
//           lastChild.textContent = "OFF"; // Appends text
//         }
//       }, 1000);
//       clearInterval(checkDiscountInterval); // Stop checking
//     } else {
//       console.log("Waiting for element...");
//       setTimeout(() => {
//         clearInterval(checkDiscountInterval); // Stop checking
//       }, 10000);
//     }
//   }, 500);
// } else {
//   const checkExistingDiscountInterval = setInterval(() => {
//     const gf_product_prices = document.querySelector(".gf_product-prices");
  
//     if (gf_product_prices) {
//       const select_discount = gf_product_prices.querySelector(".gf_pq-discount-selector");
//       gf_product_prices.setAttribute("id", "gf--discount_prices--value");
//       select_discount.setAttribute("id", "gf--discount-value");
//       clearInterval(checkExistingDiscountInterval); // Stop checking
//     } else {
//       console.log("Waiting for element...");
//       setTimeout(() => {
//         clearInterval(checkExistingDiscountInterval); // Stop checking
//       }, 10000);
//     }
//   }, 500);
// }
/************ DISCOUNT VIEW END **************/